import { madeRequest } from '../../helpers/api'
import { ENDPOINTS } from '../../constants/api'

// PLOP_APPEND_PATTERN_ANCHOR
export function getDv360ChannelsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.dv360Channels
  })
}
export function getDv360TargetingOptionsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.targetingOptions
  })
}

export function getDv360TargetingService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.targeting
  })
}

export function searchTargetingOptionsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.targetingOptionsSearch
  })
}

export function updateDv360BulkTargetingService(targetingData) {
  return madeRequest('PATCH', {
    data: targetingData,
    url: ENDPOINTS.targetingBulkUpdate
  })
}

export function getDv360NegativeKeywordListsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.negativeKeywordLists
  })
}
